<div class="rs-panel-big rs-bg-c2">
  <ng-container *ngFor="let aProductSplit of productSplit">
    <div class="rs-entrypoint-container" *ngIf="aProductSplit.identifier">
      <my-bill-odb-section-variant-two
        [isClickable]="aProductSplit.categoryDetails"
        [label]="aProductSplit.identifier"
        [amount]="aProductSplit.amount"
        linkZone="mybill.detail.thirdParty"
        (sectionClick)="navigateToL3(aProductSplit)"
      >
      </my-bill-odb-section-variant-two>
    </div>
    <ng-container
      *ngIf="!aProductSplit.identifier && aProductSplit.categoryDetails"
    >
      <ng-container
        *ngFor="let categoryDetail of aProductSplit.categoryDetails"
      >
        <my-bill-odb-category-section-or-item-variant-one
          *ngFor="let section of categoryDetail.sections"
          [section]="section"
          [categoryDetailValidFor]="categoryDetail.validFor"
          categoryType="thirdParty"
        >
        </my-bill-odb-category-section-or-item-variant-one>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<div
  class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
  my-bill-odb-total
  [amount]="totalAmount"
></div>
